/**
 *  AenaPointsList script file
**/
import { GETTERS } from '@/store'
import { mapGetters } from 'vuex'
import { normalizeLowerCase } from '@/utils/matchString'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaPointsList',
  mixins: [setDeviceWidthClass],
  components: {},
  props: {
    points: {
      type: Array,
      required: true
    },
    headerHeight: {
      type: Number,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters({
      airportID: GETTERS.GET_AIRPORT_ID
    })
  },
  mounted () {
    // NOTE: accessibility trick
    this.$refs.scrollContent.addEventListener('mouseover', () => {
      this.$refs.scrollContent.style.visibility = 'visible'
    }, false)
    this.$refs.scrollContent.addEventListener('mouseout', () => {
      this.$refs.scrollContent.style.visibility = 'hidden'
    }, false)
  },
  methods: {
    selectPoint (category) {
      this.$emit('onSelect', { category, component: 'aena-points-categories' })

      const tag = {
        'eventCategory': 'buscador',
        'eventAction': 'punto de interes',
        'eventLabel': `${normalizeLowerCase(category.name)}`,
        'language': this.$i18n.locale,
        'airportID': this.airportID
      }
      window.digitalChange('event', tag)
    },
    goBack () {
      this.$emit('onSelect', { component: 'aena-highlighted-points' })
    }
  }
}
